var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('span',{staticClass:"close-grafico",on:{"click":_vm.close}},[_vm._v("×")]),_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }